// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"4954a7d144d449ddde7b","303":"7981987fa04889aaa3cc","495":"3276d98e8b3eca53c9a4"}[chunkId] + ".js";
};